import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";

const ModalWindow = (function () {
  const modalWindowWrapperSelector = ".js-modal-wrapper";
  const modalWindowInsideSelector = ".js-modal-window-inside";
  const modalWindowCloseButtonSelector = ".js-close-modal-btn";
  const crisisModalWrapperSelector = ".crisis-information__modal-wrapper";
  const frontifyModalWrapperSelector = ".frontify-modal__wrapper";

  const $crisisModalWrapper = $(
    modalWindowWrapperSelector + crisisModalWrapperSelector,
  );
  const $frontifyModalWrapper = $(
    modalWindowWrapperSelector + frontifyModalWrapperSelector,
  );

  const crisisModalExists = $crisisModalWrapper.length > 0;
  const frontifyModalExists = $frontifyModalWrapper.length > 0;

  const timeLong = 300;

  function init() {
    const crisisModalClosed =
      window?.sessionStorage.getItem("crisisModalClosed") === "true";
    if (crisisModalExists && (!window.sessionStorage || !crisisModalClosed)) {
      initCrisisModal();
    }
    if (frontifyModalExists) {
      initfrontifyModal();
      reBindClickEventAfterMoreItemsAreFetched();
    }
  }

  function initCrisisModal() {
    $crisisModalWrapper.openModal();
    $crisisModalWrapper.closeModalOnClickOutside();
    $crisisModalWrapper.closeModalOnClickCloseButton();
  }

  function initfrontifyModal() {
    fetchFrontifyInfoAndOpenModalOnClick(timeLong);
    $frontifyModalWrapper.closeModalOnClickOutside(timeLong);
    $frontifyModalWrapper.closeModalOnClickCloseButton(timeLong);
  }

  function reBindClickEventAfterMoreItemsAreFetched() {
    $(".js-show-more-listing-items").on("click", function () {
      $(document).ajaxStop(function () {
        $(".js-frontify-modal").off();
        fetchFrontifyInfoAndOpenModalOnClick(timeLong);
      });
    });
  }

  $.fn.closeModalOnClickOutside = function (animationTime = 0) {
    const $thisModal = $(this);
    const $modalWindowInside = $(this).find(modalWindowInsideSelector);
    $thisModal.on("click", function (e) {
      if (!$(e.target).closest($modalWindowInside).length) {
        $thisModal.closeModal(animationTime);
      }
    });
    return $(this);
  };

  $.fn.closeModalOnClickCloseButton = function (animationTime = 0) {
    const $thisModal = $(this);
    $thisModal.find(modalWindowCloseButtonSelector).on("click", function () {
      $thisModal.closeModal(animationTime);
    });
    return $(this);
  };

  $.fn.openModal = function (animationTime = 0) {
    $(this).fadeIn(animationTime);
    disableBodyScroll($(this).get(0)!);
    return $(this);
  };

  $.fn.closeModal = function (animationTime = 0) {
    $(this).fadeOut(animationTime);
    enableBodyScroll($(this).get(0)!);
    if (
      $(this).hasClass(crisisModalWrapperSelector.substring(1)) &&
      window.sessionStorage
    ) {
      sessionStorage.setItem("crisisModalClosed", "true");
    }
    return $(this);
  };

  function fetchFrontifyInfoAndOpenModalOnClick(animationTime = 0) {
    $(".js-frontify-modal").on("click", function () {
      const params = new URL(window.location.href).searchParams;
      const category = params.get("f");

      const data = {
        tag: $(this).data("tag"),
        category: category || "",
      };

      const searchParams = new URLSearchParams(data);

      $.ajax({
        url: "getmodalinfo?" + searchParams.toString(),
        dataType: "html",
        success: function (modalContent) {
          $(".js-frontify-modal-content").html(modalContent);

          addEventListeners();

          $frontifyModalWrapper.openModal(animationTime);
        },
      });
    });
  }

  function addEventListeners() {
    const updateImageButtons = $(
      ".js-frontify-modal-content .js-frontify-update-image",
    );

    const images = $(".js-modal-image");

    const imageActiveClass = "frontify-modal__image__wrapper--active";

    updateImageButtons.on("click", function () {
      const target = $(this).data("target");

      images.removeClass(imageActiveClass);
      $("#" + target).addClass(imageActiveClass);
    });
  }

  return {
    init,
  };
})();

export default ModalWindow;
